/*
  LP media veil —— 大图蒙版的触摸端行为。

  桌面端不归它管：悬停和键盘焦点由各 section 里的 @media (hover: hover) 负责。
  这里只接管 (hover: none) 的触摸设备，因为纯 CSS 做不到下面这套点击流程。

  行为：
    点大图       展开蒙版和按钮
    点按钮       跳转
    再点大图     收起
    点图片之外   收起（没有这条的话，展开态会一直黏在屏幕上）

  约定（由 section 输出）：
    [data-lp-veil]       承载蒙版的容器（figure）
    [data-lp-veil-btn]   里面的按钮，用来区分「点按钮」和「点图的其它位置」
    .is-veil-open        展开态，CSS 只认这个类

  未展开时蒙版和按钮都是 pointer-events: none，所以第一次点击必然落在
  图片本身（也就是容器）上，不会误触发里面的链接。
  文档级监听走捕获阶段，别的脚本 stopPropagation 也挡不住收起。

  用法：lp-style-quad.liquid / lp-editorial-feature.liquid 各引一次，
  一页上可能同时出现这两个 section，故用全局开关保证只执行一次。
*/
(function () {
  'use strict';

  if (window.__lpMediaVeil) return;
  window.__lpMediaVeil = true;

  var CONTAINER = '[data-lp-veil]';
  var BUTTON = '[data-lp-veil-btn]';
  var OPEN = 'is-veil-open';

  /* 每次现查、不缓存：插拔鼠标或设备旋转都会改变这个查询的结果 */
  function isTouch() {
    return window.matchMedia('(hover: none)').matches;
  }

  function closeAll(except) {
    var open = document.querySelectorAll(CONTAINER + '.' + OPEN);
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) open[i].classList.remove(OPEN);
    }
  }

  document.addEventListener('click', function (event) {
    if (!isTouch()) return;

    var target = event.target;
    if (!target || !target.closest) return;

    var veil = target.closest(CONTAINER);

    /* 点在图片之外 —— 收起所有已展开的蒙版 */
    if (!veil) {
      closeAll(null);
      return;
    }

    if (veil.classList.contains(OPEN)) {
      /* 已展开：点在按钮上就放行，浏览器自己跳转；点在图上别处则收起 */
      if (target.closest(BUTTON)) return;
      veil.classList.remove(OPEN);
      return;
    }

    /* 未展开：只展开，不跳转。顺手把别的图收起来，避免同时开着好几个 */
    closeAll(veil);
    veil.classList.add(OPEN);
  }, true);
}());
